import { round } from 'lodash';
import MersenneTwister from 'mersennetwister';

function createQuestionId() {
    const mt = new MersenneTwister();
    const time = round(new Date().getTime() / 1000).toString(16);
    const random = (mt.rnd() * 1000000000000000000).toString(16);
    return (time + random).substr(0, 18);
}

export default createQuestionId;
